import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "full", "moreButton", "closeButton"]

  connect() {
    this.collapse()
  }

  expand() {
    this.previewTarget.hidden = true
    this.fullTarget.hidden = false
    this.moreButtonTarget.hidden = true
    this.closeButtonTarget.hidden = false
    this.element.setAttribute("aria-expanded", "true")
  }

  collapse() {
    this.previewTarget.hidden = false
    this.fullTarget.hidden = true
    this.moreButtonTarget.hidden = false
    this.closeButtonTarget.hidden = true
    this.element.setAttribute("aria-expanded", "false")
  }
}
